<template>
    <div class="row">

        <div class="col-md-4 col-12">
            <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="getuserId" :rownumintable="3"
                :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserId'" :keyItem="'UserId0'"
                :ClassProps="'required'" :disabled="false"> </SearchableCombo>
        </div>
    </div>
</template>
<script>
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
    components: { SearchableCombo },
    props: ['item'],
    data() {
        return {
            userId: null,
        }
    },
    methods: {
        submit() {
            let model = {
                UserId: this.userId,
                AutomationeDepartmenId: this.item.id,
            }
            this.$PostData_new("post", "AutomationDepartment/AddUser", model).then((res) => {
                if (res.isSuccess) {
                    this.$mySweetDefaultTost('عملیات موفق', res.message, 'success', 2000)
                    this.$emit("Result", res.isSuccess)
                }else{
                    this.$mySweetDefaultTost('عملیات ناموفق', res.message, 'error', 2000)
                }
            }).catch((err) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطا در خواندن دپارتمان داد', 'error', 2000)
                console.error(err)
            })
        },
        getuserId(data) {
            if (data.id != null) {
                this.userId = data.id
                this.submit()
            }
        },
    }

}
</script>